






























import { mapGetters, mapActions } from 'vuex'
import AdminNavbar from '@/components/AdminNavbar.vue'
import UserModal from '@/components/UserModal.vue'

export default {
  name: 'AdminAssessments',
  components: {
    AdminNavbar,
    UserModal,
  },
  data () {
    return {
      userList: [],
      assessments: []
    }
  },
  computed: {
    ...mapGetters([
      'assessmentsList'
    ]),
    adminUsers () {
      const adminUsers = []
      for (let u=0; u<this.userList.length; u++) {
        if (this.userList[u].role === 'admin') {
          adminUsers.push(this.userList[u])
        }
      }
      return adminUsers
    }
  },
  methods: {
    ...mapActions([
      'getUsers',
      'loadAssessmentsList'
    ]),

    showBankDetails (bank: Bank) {
      this.$router.push('/admin/banks/'+bank.id)
    },

    async loadUsers () {
      console.log('loadUsers')
      const result = await this.getUsers()
      console.log('  loadUsers result', result)
      if (result.success) {
        this.userList = result.data
      }
    },

    newUser () {
      this.$refs.userModal.show({role: 'admin'})
    },

    editUser (user: User) {
      this.$refs.userModal.loadAndShow(user)
    },

    newQuestionnaire () {

    },

  },
  mounted () {
      this.loadUsers()
      this.loadAssessmentsList()
  }
}
